import Report from "../../components/private/report";

export default () => {
  return <Report />;
};
